module.exports = __webpack_public_path__ + "img/placeholder.12530fda.png";